export const defaultStatuses = [
  'Open',
  'Attached',
  'Choices',
  'Offer',
  'Negotiation',
  'In Discussions',
  'Interested In',
  'Set',
  'On Hiatus',
  'Filled',
  'Likely Filled',
  'Shortlist',
];

const tvStatuses = ['Test Offer', 'Test Offer Coming'];

export const personOptionalStatuses = ['Open', 'Filled', 'Likely Filled', 'Shortlist'];

export const isPersonOptionalStatus = status => personOptionalStatuses.includes(status);

export const isStatusPersonAssignmentValid = (status, personId) => {
  if (status === 'Open') return !personId;
  if (isPersonOptionalStatus(status)) return true;
  return !!personId;
};

export const statusesByProjectType = {
  Feature: defaultStatuses,
  Television: defaultStatuses.concat(tvStatuses),
  Unscripted: defaultStatuses.concat(['Submitted']),
  Theatre: defaultStatuses,
  'Fairs and Festivals': defaultStatuses,
};
